import { MS_INBOX_TOGGLE_CHAT_BOT_PATH } from '../../constants/AppConstants';
import fetchWithTimeout from '../../util/fetchWithTimeout';
import { msInboxApiUrl, buildMsInboxAuthHeaders, requireMsApiPlatform } from './msInboxClient';

/**
 * PUT toggle_chat_bot contra el microservicio inbox.
 * Habilita/deshabilita el chatbot de un chat (TikTok / Messenger).
 * @param {{ id: *, platform: string, enabled: boolean }} payload
 */
export async function toggleChatBotMsInbox(payload) {
  const url = msInboxApiUrl(MS_INBOX_TOGGLE_CHAT_BOT_PATH);
  const headers = await buildMsInboxAuthHeaders();

  const platform = requireMsApiPlatform(payload?.platform, 'toggle_chat_bot');

  const body = {
    id: payload?.id,
    platform,
    enabled: payload?.enabled
  };

  const response = await fetchWithTimeout(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
    mode: 'cors'
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    const errorMessage = errorDetails.message
      || errorDetails.error
      || errorDetails?.errors
      || `HTTP error! Status: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return response.json().catch(() => null);
}
